import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import ArticlesPage from './pages/ArticlesPage';
import ArticleForm from './components/ArticleForm';
import ContactsPage from './pages/ContactsPage';
import CareersPage from './pages/CareersPage';
import CareerForm from './components/CareerForm';
import ApplicationsPage from './pages/ApplicationsPage';
import ResourcesPage from './pages/ResourcesPage';
import ResourceForm from './components/ResourceForm';
import ClientsPage from './pages/ClientsPage';
import ClientForm from './components/ClientForm';
import UsersPage from './pages/UsersPage';
import UserForm from './components/UserForm';
import LoginPage from './pages/LoginPage';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';
import ServicesPage from './pages/ServicesPage';
import ServiceForm from './components/ServiceForm';
import TeamPage from './pages/TeamPage';
import TeamForm from './components/TeamForm';
import BlogForm from './components/BlogForm';
import BlogPage from './pages/BlogList';
import AuthorPage from './pages/AuthorList';
import AuthorForm from './components/AuthorForm';
import PageContentList from './pages/PageContentList';
import PageContentForm from './components/PageContentForm';
import GlobalSettingsList from './pages/GlobalSettingsList';
import GlobalSettingsForm from './components/GlobalSettingsForm';
import WhitePaperList from './pages/WhitePaperList';
import WhitePaperForm from './components/WhitePaperForm';
import WhitePaperRequestsPage from './pages/WhitePaperRequestsPage';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected Routes */}
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />

        {/* Users */}
        <Route path="/users" element={<PrivateRoute><UsersPage /></PrivateRoute>} />
        <Route path="/users/create" element={<PrivateRoute><UserForm /></PrivateRoute>} />
        <Route path="/users/edit/:id" element={<PrivateRoute><UserForm /></PrivateRoute>} />

        {/* Contacts */}
        <Route path="/contacts" element={<PrivateRoute><ContactsPage /></PrivateRoute>} />

        {/* Careers */}
        <Route path="/careers" element={<PrivateRoute><CareersPage /></PrivateRoute>} />
        <Route path="/careers/create" element={<PrivateRoute><CareerForm /></PrivateRoute>} />
        <Route path="/careers/edit/:id" element={<PrivateRoute><CareerForm /></PrivateRoute>} />

        {/* Applications */}
        <Route path="/applications" element={<PrivateRoute><ApplicationsPage /></PrivateRoute>} />

        {/* Resources */}
        <Route path="/resources" element={<PrivateRoute><ResourcesPage /></PrivateRoute>} />
        <Route path="/resources/create" element={<PrivateRoute><ResourceForm /></PrivateRoute>} />
        <Route path="/resources/edit/:id" element={<PrivateRoute><ResourceForm /></PrivateRoute>} />

        {/* Clients */}
        <Route path="/clients" element={<PrivateRoute><ClientsPage /></PrivateRoute>} />
        <Route path="/clients/create" element={<PrivateRoute><ClientForm /></PrivateRoute>} />
        <Route path="/clients/edit/:id" element={<PrivateRoute><ClientForm /></PrivateRoute>} />

        {/* Services */}
        <Route path="/services" element={<PrivateRoute><ServicesPage /></PrivateRoute>} />
        <Route path="/services/create" element={<PrivateRoute><ServiceForm /></PrivateRoute>} />
        <Route path="/services/edit/:id" element={<PrivateRoute><ServiceForm /></PrivateRoute>} />

        {/* Team */}
        <Route path="/team" element={<PrivateRoute><TeamPage /></PrivateRoute>} />
        <Route path="/team/create" element={<PrivateRoute><TeamForm /></PrivateRoute>} />
        <Route path="/team/edit/:id" element={<PrivateRoute><TeamForm /></PrivateRoute>} />

        {/* Blogs */}
        <Route path="/blogs" element={<PrivateRoute><BlogPage /></PrivateRoute>} />
        <Route path="/blogs/create" element={<PrivateRoute><BlogForm /></PrivateRoute>} />
        <Route path="/blogs/edit/:id" element={<PrivateRoute><BlogForm /></PrivateRoute>} />

        {/* Authors */}
        <Route path="/authors" element={<PrivateRoute><AuthorPage /></PrivateRoute>} />
        <Route path="/authors/create" element={<PrivateRoute><AuthorForm /></PrivateRoute>} />
        <Route path="/authors/edit/:id" element={<PrivateRoute><AuthorForm /></PrivateRoute>} />

        {/* Page Content */}
        <Route path="/page-contents" element={<PrivateRoute><PageContentList /></PrivateRoute>} />
        <Route path="/page-contents/create" element={<PrivateRoute><PageContentForm /></PrivateRoute>} />
        <Route path="/page-contents/edit/:id" element={<PrivateRoute><PageContentForm /></PrivateRoute>} />

        {/* Global Settings */}
        <Route path="/global-settings" element={<PrivateRoute><GlobalSettingsList /></PrivateRoute>} />
        <Route path="/global-settings/create" element={<PrivateRoute><GlobalSettingsForm /></PrivateRoute>} />
        <Route path="/global-settings/edit/:id" element={<PrivateRoute><GlobalSettingsForm /></PrivateRoute>} />

        {/* New White Papers Routes */}
        <Route path="/whitepapers" element={<PrivateRoute><WhitePaperList /></PrivateRoute>} />
        <Route path="/whitepapers/create" element={<PrivateRoute><WhitePaperForm /></PrivateRoute>} />
        <Route path="/whitepapers/edit/:id" element={<PrivateRoute><WhitePaperForm /></PrivateRoute>} />
        <Route
          path="/whitepaper-requests"
          element={
            <PrivateRoute>
              <WhitePaperRequestsPage />
            </PrivateRoute>
          }
        />
        {/* Catch all unknown routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
